import { createSelector } from 'reselect';
import { last } from 'core/utils/fp';

const getState = (state) => state.notifications;

export const getNotifications = createSelector(getState, (state) => state);

export const getNotification = createSelector(getState, (state) => last(state));
